export const affiliateFallbackData = [
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Cambodia",
      "loginEnabled":false,
      "label":"Cambodia",
      "defaultTimezone":"Asia/Bangkok",
      "defaultLocale":"th_TH",
      "defaultLanguage":"th",
      "availableLanguages":[
         "th"
      ],
      "affiliate":"KH"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Spain",
      "loginEnabled":true,
      "label":"Spain",
      "defaultTimezone":"Europe/Brussels",
      "defaultLocale":"es_ES",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es"
      ],
      "affiliate":"ES"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Finland",
      "loginEnabled":true,
      "label":"Finland",
      "defaultTimezone":"Europe/Helsinki",
      "defaultLocale":"fi_FI",
      "defaultLanguage":"fi",
      "availableLanguages":[
         "fi"
      ],
      "affiliate":"FI"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":true,
      "name":"China",
      "loginEnabled":true,
      "label":"China",
      "defaultTimezone":"Asia/Shanghai",
      "defaultLocale":"zh_CN",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "zh_CN",
         "en_US"
      ],
      "affiliate":"CN"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Belgium",
      "loginEnabled":true,
      "label":"Belgium",
      "defaultTimezone":"Europe/Brussels",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US",
         "fr_BE",
         "nl_BE"
      ],
      "affiliate":"BE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "namingFormat":"SL-LN",
      "name":"France",
      "loginEnabled":true,
      "label":"France",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"fr_FR",
      "defaultLanguage":"fr",
      "availableLanguages":[
         "fr",
         "en_US"
      ],
      "affiliate":"FR"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":true,
      "name":"United Arab Emirates",
      "loginEnabled":true,
      "label":"United Arab Emirates",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"ar_AE",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"AE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"United Kingdom",
      "loginEnabled":true,
      "label":"United Kingdom",
      "defaultTimezone":"Europe/London",
      "defaultLocale":"en_gb",
      "defaultLanguage":"en_gb",
      "availableLanguages":[
         "en_gb",
         "en_us"
      ],
      "affiliate":"GB"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "namingFormat":"SL-FN-LN",
      "name":"Hong Kong",
      "loginEnabled":true,
      "label":"Hong Kong",
      "defaultTimezone":"Asia/Hong_Kong",
      "defaultLocale":"en_HK",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"HK"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Hungary",
      "loginEnabled":true,
      "label":"Hungary",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"hu_HU",
      "defaultLanguage":"hu",
      "availableLanguages":[
         "hu",
         "en_US"
      ],
      "affiliate":"HU"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "namingFormat":"SL-FN-MN-LN",
      "name":"Indonesia",
      "loginEnabled":true,
      "label":"Indonesia",
      "defaultTimezone":"Asia/Singapore",
      "defaultLocale":"en_ID",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"ID"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Ireland",
      "mappedToAffiliate":"GB",
      "loginEnabled":false,
      "label":"Ireland",
      "defaultTimezone":"Europe/Dublin",
      "defaultLocale":"en_IE",
      "defaultLanguage":"en_GB",
      "availableLanguages":[
         "en_GB"
      ],
      "affiliate":"IE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "namingFormat":"SL-FN-MN-LN",
      "name":"India",
      "loginEnabled":true,
      "label":"India",
      "defaultTimezone":"Asia/Colombo",
      "defaultLocale":"en_IN",
      "defaultLanguage":"en_GB",
      "availableLanguages":[
         "en_GB"
      ],
      "affiliate":"IN"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Iceland",
      "loginEnabled":false,
      "label":"Iceland",
      "defaultTimezone":"GMT",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"IS"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"South Korea",
      "loginEnabled":true,
      "label":"South Korea",
      "defaultTimezone":"Asia/Seoul",
      "defaultLocale":"ko_KR",
      "defaultLanguage":"ko",
      "availableLanguages":[
         "ko"
      ],
      "affiliate":"KR"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Liechtenstein",
      "loginEnabled":false,
      "label":"Liechtenstein",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"de_CH",
      "defaultLanguage":"de_CH",
      "availableLanguages":[
         "de_CH"
      ],
      "affiliate":"LI"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Lithuania",
      "loginEnabled":true,
      "label":"Lithuania",
      "defaultTimezone":"Europe/Helsinki",
      "defaultLocale":"lt_LT",
      "defaultLanguage":"lt",
      "availableLanguages":[
         "lt",
         "en_US"
      ],
      "affiliate":"LT"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Luxembourg",
      "loginEnabled":false,
      "label":"Luxembourg",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"en_LU",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "fr",
         "de",
         "en_US"
      ],
      "affiliate":"LU"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Latvia",
      "loginEnabled":true,
      "label":"Latvia",
      "defaultTimezone":"Europe/Helsinki",
      "defaultLocale":"lv_LV",
      "defaultLanguage":"lv",
      "availableLanguages":[
         "lv",
         "en_US"
      ],
      "affiliate":"LV"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Malta",
      "loginEnabled":false,
      "label":"Malta",
      "defaultTimezone":"Europe/Rome",
      "defaultLocale":"en_MT",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"MT"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "namingFormat":"SL-FN-MN-LN",
      "name":"Malaysia",
      "loginEnabled":true,
      "label":"Malaysia",
      "defaultTimezone":"Asia/Kuala_Lumpur",
      "defaultLocale":"en_MY",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"MY"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Netherlands",
      "loginEnabled":true,
      "label":"Netherlands",
      "defaultTimezone":"Europe/Amsterdam",
      "defaultLocale":"nl_NL",
      "defaultLanguage":"nl_NL",
      "availableLanguages":[
         "nl_NL"
      ],
      "affiliate":"NL"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Norway",
      "loginEnabled":true,
      "label":"Norway",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"no_NO",
      "defaultLanguage":"no",
      "availableLanguages":[
         "no"
      ],
      "affiliate":"NO"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Chile",
      "loginEnabled":true,
      "label":"Chile",
      "defaultTimezone":"America/Santiago",
      "defaultLocale":"es_CL",
      "defaultLanguage":"es_CL",
      "availableLanguages":[
         "es_CL"
      ],
      "affiliate":"CL"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Colombia",
      "loginEnabled":true,
      "label":"Colombia",
      "defaultTimezone":"America/Bogota",
      "defaultLocale":"es_CO",
      "defaultLanguage":"es_CO",
      "availableLanguages":[
         "es_CO"
      ],
      "affiliate":"CO"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Cyprus",
      "loginEnabled":false,
      "label":"Cyprus",
      "defaultTimezone":"Europe/Athens",
      "defaultLocale":"el_CY",
      "defaultLanguage":"el",
      "availableLanguages":[
         "el"
      ],
      "affiliate":"CY"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Czech Republic",
      "loginEnabled":true,
      "label":"Czech Republic",
      "defaultTimezone":"Europe/Prague",
      "defaultLocale":"cs_CZ",
      "defaultLanguage":"cs",
      "availableLanguages":[
         "cs"
      ],
      "affiliate":"CZ"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Denmark",
      "loginEnabled":true,
      "label":"Denmark",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"da_DK",
      "defaultLanguage":"da",
      "availableLanguages":[
         "da"
      ],
      "affiliate":"DK"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Ecuador",
      "loginEnabled":true,
      "label":"Ecuador",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_EC",
      "defaultLanguage":"es_EC",
      "availableLanguages":[
         "es_EC"
      ],
      "affiliate":"EC"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Estonia",
      "loginEnabled":false,
      "label":"Estonia",
      "defaultTimezone":"Europe/Helsinki",
      "defaultLocale":"et_EE",
      "defaultLanguage":"et",
      "availableLanguages":[
         "et",
         "en_US"
      ],
      "affiliate":"EE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "namingFormat":"LN-FN-SL",
      "name":"Taiwan",
      "loginEnabled":true,
      "label":"Taiwan",
      "defaultTimezone":"Asia/Shanghai",
      "defaultLocale":"zh_tw",
      "defaultLanguage":"zh_tw",
      "availableLanguages":[
         "en_US",
         "zh_TW"
      ],
      "affiliate":"TW"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Ukraine",
      "loginEnabled":false,
      "label":"Ukraine",
      "defaultTimezone":"Europe/Bucharest",
      "defaultLocale":"en_UA",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"UA"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":true,
      "namingFormat":"SL-LN",
      "name":"United States",
      "loginEnabled":true,
      "label":"United States",
      "defaultTimezone":"America/Indiana/Indianapolis",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"US"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Uruguay",
      "loginEnabled":true,
      "label":"Uruguay",
      "defaultTimezone":"America/Sao_Paulo",
      "defaultLocale":"es_UY",
      "defaultLanguage":"es_UY",
      "availableLanguages":[
         "es_UY"
      ],
      "affiliate":"UY"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Venezuela",
      "loginEnabled":true,
      "label":"Venezuela",
      "defaultTimezone":"America/Caracas",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es_PA",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"VE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Vietnam",
      "loginEnabled":true,
      "label":"Vietnam",
      "defaultTimezone":"Asia/Ho_Chi_Minh",
      "defaultLocale":"vi_VN",
      "defaultLanguage":"vi",
      "availableLanguages":[
         "vi",
         "en_US"
      ],
      "affiliate":"VN"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"South Africa",
      "loginEnabled":true,
      "label":"South Africa",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"ZA"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Germany",
      "loginEnabled":true,
      "label":"Germany",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"de_DE",
      "defaultLanguage":"de",
      "availableLanguages":[
         "de",
         "en_US"
      ],
      "affiliate":"DE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "namingFormat":"LN-FN-SL",
      "name":"Japan",
      "loginEnabled":true,
      "label":"Japan",
      "defaultTimezone":"Asia/Tokyo",
      "defaultLocale":"ja_JP",
      "defaultLanguage":"ja",
      "availableLanguages":[
         "ja"
      ],
      "affiliate":"JP"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Madagascar",
      "loginEnabled":true,
      "label":"Madagascar",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"MG"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Mali",
      "loginEnabled":true,
      "label":"Mali",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"ML"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Martinique",
      "loginEnabled":true,
      "label":"Martinique",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"MQ"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Mauritania",
      "loginEnabled":true,
      "label":"Mauritania",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"MR"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Niger",
      "mappedToAffiliate":"FR",
      "loginEnabled":true,
      "label":"Niger",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"NE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Sierra Leone",
      "loginEnabled":true,
      "label":"Sierra Leone",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"SL"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Senegal",
      "loginEnabled":true,
      "label":"Senegal",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"SN"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Sao Tome and Principe",
      "loginEnabled":true,
      "label":"Sao Tome and Principe",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"ST"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Argentina",
      "loginEnabled":true,
      "label":"Argentina",
      "defaultTimezone":"America/Argentina/Buenos_Aires",
      "defaultLocale":"es_AR",
      "defaultLanguage":"es_AR",
      "availableLanguages":[
         "es_AR"
      ],
      "affiliate":"AR"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Austria",
      "loginEnabled":true,
      "label":"Austria",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"de_AT",
      "defaultLanguage":"de_AT",
      "availableLanguages":[
         "de_AT",
         "en_US"
      ],
      "affiliate":"AT"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Switzerland",
      "loginEnabled":true,
      "label":"Switzerland",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"de_CH",
      "defaultLanguage":"de_CH",
      "availableLanguages":[
         "en_US",
         "de_CH",
         "fr_CH",
         "it_CH"
      ],
      "affiliate":"CH"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Greece",
      "loginEnabled":true,
      "label":"Greece",
      "defaultTimezone":"Europe/Athens",
      "defaultLocale":"el_GR",
      "defaultLanguage":"el",
      "availableLanguages":[
         "el",
         "en_US"
      ],
      "affiliate":"GR"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Italy",
      "loginEnabled":true,
      "label":"Italy",
      "defaultTimezone":"Europe/Rome",
      "defaultLocale":"it_IT",
      "defaultLanguage":"it",
      "availableLanguages":[
         "it",
         "en_US"
      ],
      "affiliate":"IT"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":true,
      "name":"Mexico",
      "loginEnabled":true,
      "label":"Mexico",
      "defaultTimezone":"America/Mexico_City",
      "defaultLocale":"es_MX",
      "defaultLanguage":"es_MX",
      "availableLanguages":[
         "es_MX"
      ],
      "affiliate":"MX"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Bulgaria",
      "loginEnabled":false,
      "label":"Bulgaria",
      "defaultTimezone":"Europe/Bukarest",
      "defaultLocale":"bg_BG",
      "defaultLanguage":"bg",
      "availableLanguages":[
         "bg"
      ],
      "affiliate":"BG"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Brazil",
      "loginEnabled":true,
      "label":"Brazil",
      "defaultTimezone":"America/Sao_Paulo",
      "defaultLocale":"pt_BR",
      "defaultLanguage":"pt_BR",
      "availableLanguages":[
         "pt_BR"
      ],
      "affiliate":"BR"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Canada",
      "loginEnabled":true,
      "label":"Canada",
      "defaultTimezone":"America/Chicago",
      "defaultLocale":"en_CA",
      "defaultLanguage":"en_CA",
      "availableLanguages":[
         "en_CA",
         "fr_CA"
      ],
      "affiliate":"CA"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Portugal",
      "loginEnabled":true,
      "label":"Portugal",
      "defaultTimezone":"Europe/Lisbon",
      "defaultLocale":"pt_PT",
      "defaultLanguage":"pt_PT",
      "availableLanguages":[
         "pt_PT"
      ],
      "affiliate":"PT"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Romania",
      "loginEnabled":true,
      "label":"Romania",
      "defaultTimezone":"Europe/Bucharest",
      "defaultLocale":"ro_RO",
      "defaultLanguage":"ro",
      "availableLanguages":[
         "ro",
         "en_US"
      ],
      "affiliate":"RO"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Russia",
      "loginEnabled":true,
      "label":"Russia",
      "defaultTimezone":"Europe/Moscow",
      "defaultLocale":"ru_RU",
      "defaultLanguage":"ru",
      "availableLanguages":[
         "ru",
         "en_GB"
      ],
      "affiliate":"RU"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Sweden",
      "loginEnabled":true,
      "label":"Sweden",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"sv_SE",
      "defaultLanguage":"sv",
      "availableLanguages":[
         "sv",
         "en_US"
      ],
      "affiliate":"SE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "namingFormat":"SL-FN-MN-LN",
      "name":"Singapore",
      "loginEnabled":true,
      "label":"Singapore",
      "defaultTimezone":"Asia/Singapore",
      "defaultLocale":"en_SG",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"SG"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Slovenia",
      "loginEnabled":true,
      "label":"Slovenia",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"sl_SI",
      "defaultLanguage":"sl",
      "availableLanguages":[
         "sl",
         "en_GB"
      ],
      "affiliate":"SI"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Slovakia",
      "loginEnabled":true,
      "label":"Slovakia",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"sk_SK",
      "defaultLanguage":"sk",
      "availableLanguages":[
         "sk",
         "en_US"
      ],
      "affiliate":"SK"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Thailand",
      "loginEnabled":true,
      "label":"Thailand",
      "defaultTimezone":"Asia/Bangkok",
      "defaultLocale":"th_TH",
      "defaultLanguage":"th",
      "availableLanguages":[
         "th"
      ],
      "affiliate":"TH"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Turkey",
      "loginEnabled":true,
      "label":"Turkey",
      "defaultTimezone":"Europe/Istanbul",
      "defaultLocale":"tr_TR",
      "defaultLanguage":"tr",
      "availableLanguages":[
         "tr",
         "en_US",
         "ru"
      ],
      "affiliate":"TR"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Dominican Republic",
      "loginEnabled":true,
      "label":"Dominican Republic",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"DO"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Curacao",
      "loginEnabled":true,
      "label":"Curacao",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"CW"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Guyana",
      "loginEnabled":true,
      "label":"Guyana",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"GY"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Algeria",
      "mappedToAffiliate":"FR",
      "loginEnabled":true,
      "label":"Algeria",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"fr_FR",
      "defaultLanguage":"fr",
      "availableLanguages":[
         "fr",
         "en_US"
      ],
      "affiliate":"AL"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Benin",
      "loginEnabled":true,
      "label":"Benin",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"fr_FR",
      "defaultLanguage":"fr",
      "availableLanguages":[
         "fr",
         "en_US"
      ],
      "affiliate":"BJ"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Cote d'Ivoire",
      "loginEnabled":true,
      "label":"Ivory Coast",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"CI"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Cameroon",
      "loginEnabled":true,
      "label":"Cameroon",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"CM"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Cape Verde",
      "loginEnabled":true,
      "label":"Cape Verde",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"CV"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Djibouti",
      "loginEnabled":true,
      "label":"Djibouti",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"DJ"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Gabon",
      "loginEnabled":true,
      "label":"Gabon",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"GA"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Gambia",
      "loginEnabled":true,
      "label":"Gambia",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"GM"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Chad",
      "loginEnabled":true,
      "label":"Chad",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"TD"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Togo",
      "loginEnabled":true,
      "label":"Togo",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"TG"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Tunisia",
      "loginEnabled":true,
      "label":"Tunisia",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"TN"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Guinea",
      "loginEnabled":true,
      "label":"Guinea",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"GN"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Guadeloupe",
      "loginEnabled":true,
      "label":"Guadeloupe",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"GP"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Equatorial Guinea",
      "loginEnabled":true,
      "label":"Equatorial Guinea",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"GQ"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Guinea-Bissau",
      "loginEnabled":true,
      "label":"Guinea-Bissau",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"GW"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"French Guyana",
      "loginEnabled":true,
      "label":"French Guyana",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"GF"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Liberia",
      "loginEnabled":true,
      "label":"Liberia",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"LR"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Morocco",
      "loginEnabled":true,
      "label":"Morocco",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"MA",
      "defaultLanguage":"MA",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"MA"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Burkina Faso",
      "mappedToAffiliate":"FR",
      "loginEnabled":true,
      "label":"Burkina Faso",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"BF"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Central African Republic",
      "loginEnabled":true,
      "label":"Central African Republic",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"CF"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Reunion",
      "loginEnabled":true,
      "label":"Reunion",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"fr_FR",
      "defaultLanguage":"fr",
      "availableLanguages":[
         "fr",
         "en_US"
      ],
      "affiliate":"RE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":true,
      "name":"Egypt",
      "loginEnabled":true,
      "label":"Egypt",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"ar_AE",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"EG"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"All other countries",
      "loginEnabled":false,
      "label":"All other countries",
      "defaultTimezone":"GMT",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"PI"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "namingFormat":"SL-FN-MN-LN",
      "name":"Australia",
      "loginEnabled":true,
      "label":"Australia",
      "defaultTimezone":"Australia/Sydney",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"AU"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "namingFormat":"SL-FN-LN",
      "name":"New Zealand",
      "loginEnabled":true,
      "label":"New Zealand",
      "defaultTimezone":"Pacific/Auckland",
      "defaultLocale":"en_NZ",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"NZ"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Panama",
      "loginEnabled":true,
      "label":"Panama",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es_PA",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"PA"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":true,
      "name":"Peru",
      "loginEnabled":true,
      "label":"Peru",
      "defaultTimezone":"America/Lima",
      "defaultLocale":"es_PE",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es",
         "es_PE"
      ],
      "affiliate":"PE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Philippines",
      "loginEnabled":true,
      "label":"Philippines",
      "defaultTimezone":"Asia/Manila",
      "defaultLocale":"en_PH",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"PH"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "namingFormat":"SL-FN-MN-LN",
      "name":"Pakistan",
      "loginEnabled":true,
      "label":"Pakistan",
      "defaultTimezone":"Asia/Karachi",
      "defaultLocale":"en_PK",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"PK"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Poland",
      "loginEnabled":true,
      "label":"Poland",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"pl_PL",
      "defaultLanguage":"pl",
      "availableLanguages":[
         "pl"
      ],
      "affiliate":"PL"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Monaco",
      "loginEnabled":true,
      "label":"Monaco",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"MC"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Saint Kitts and Nevis",
      "loginEnabled":true,
      "label":"Saint Kitts and Nevis",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"KN"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Dominica",
      "loginEnabled":true,
      "label":"Dominica",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"DM"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"El Salvador",
      "loginEnabled":true,
      "label":"El Salvador",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"SV"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Jamaica",
      "loginEnabled":true,
      "label":"Jamaica",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"JM"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Honduras",
      "loginEnabled":true,
      "label":"Honduras",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"HN"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Trinidad and Tobago",
      "loginEnabled":true,
      "label":"Trinidad and Tobago",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"TT"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Nicaragua",
      "loginEnabled":true,
      "label":"Nicaragua",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"NI"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Barbados",
      "loginEnabled":true,
      "label":"Barbados",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"BB"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Cuba",
      "loginEnabled":true,
      "label":"Cuba",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"CU"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":true,
      "name":"Palestinian Territories",
      "loginEnabled":true,
      "label":"Palestinian Territories",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"PS"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Croatia",
      "loginEnabled":true,
      "label":"Croatia",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"hr_HR",
      "defaultLanguage":"hr",
      "availableLanguages":[
         "hr",
         "en_US"
      ],
      "affiliate":"HR"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Guatemala",
      "loginEnabled":true,
      "label":"Guatemala",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_GT",
      "defaultLanguage":"es_GT",
      "availableLanguages":[
         "es_GT"
      ],
      "affiliate":"GT"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Aruba",
      "loginEnabled":true,
      "label":"Aruba",
      "defaultTimezone":"Europe/Bucharest",
      "defaultLocale":"ro_RO",
      "defaultLanguage":"ro",
      "availableLanguages":[
         "ro",
         "en_US"
      ],
      "affiliate":"AW"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Belize",
      "loginEnabled":true,
      "label":"Belize",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"BZ"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Grenada",
      "loginEnabled":true,
      "label":"Grenada",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"GD"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Haiti",
      "loginEnabled":true,
      "label":"Haiti",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"HT"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Saint Vincent and the Grenadines",
      "loginEnabled":true,
      "label":"Saint Vincent and the Grenadines",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"VC"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Bahamas",
      "loginEnabled":true,
      "label":"Bahamas",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"BS"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Suriname",
      "loginEnabled":true,
      "label":"Suriname",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"SR"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Saudi Arabia",
      "loginEnabled":true,
      "label":"Saudi Arabia",
      "defaultTimezone":"Asia/Riyadh",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"SA"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Cayman Islands",
      "loginEnabled":true,
      "label":"Cayman Islands",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"KY"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Costa Rica",
      "loginEnabled":true,
      "label":"Costa Rica",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"CR"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Eritrea",
      "loginEnabled":true,
      "label":"Eritrea",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"fr",
      "defaultLanguage":"fr",
      "availableLanguages":[
         "fr",
         "en_ZA"
      ],
      "affiliate":"ER"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Ethiopia",
      "loginEnabled":true,
      "label":"Ethiopia",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"ET"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Ghana",
      "loginEnabled":true,
      "label":"Ghana",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"GH"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Kenya",
      "loginEnabled":true,
      "label":"Kenya",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"KE"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"British Virgin Islands",
      "loginEnabled":true,
      "label":"British Virgin Islands",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es_PA",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"VG"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Turks and Caicos Islands",
      "loginEnabled":true,
      "label":"Turks and Caicos Islands",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es_PA",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"TC"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Azerbaijan",
      "loginEnabled":true,
      "label":"Azerbaijan",
      "defaultTimezone":"Europe/Istanbul",
      "defaultLocale":"tr_TR",
      "defaultLanguage":"tr",
      "availableLanguages":[
         "tr",
         "en_US"
      ],
      "affiliate":"AZ"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Georgia",
      "loginEnabled":true,
      "label":"Georgia",
      "defaultTimezone":"Europe/Istanbul",
      "defaultLocale":"tr_TR",
      "defaultLanguage":"tr",
      "availableLanguages":[
         "tr",
         "en_US"
      ],
      "affiliate":"GE"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Kazakhstan",
      "mappedToAffiliate":"tr",
      "loginEnabled":true,
      "label":"Kazakhstan",
      "defaultTimezone":"Europe/Istanbul",
      "defaultLocale":"tr_TR",
      "defaultLanguage":"tr",
      "availableLanguages":[
         "tr",
         "en_US"
      ],
      "affiliate":"KZ"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Kyrgyzstan",
      "loginEnabled":true,
      "label":"Kyrgyzstan",
      "defaultTimezone":"Europe/Istanbul",
      "defaultLocale":"tr_TR",
      "defaultLanguage":"tr",
      "availableLanguages":[
         "tr",
         "en_US"
      ],
      "affiliate":"KG"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Tajikistan",
      "loginEnabled":true,
      "label":"Tajikistan",
      "defaultTimezone":"Europe/Istanbul",
      "defaultLocale":"tr_TR",
      "defaultLanguage":"tr",
      "availableLanguages":[
         "tr",
         "en_US"
      ],
      "affiliate":"TJ"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Turkmenistan",
      "loginEnabled":true,
      "label":"Turkmenistan",
      "defaultTimezone":"Europe/Istanbul",
      "defaultLocale":"tr_TR",
      "defaultLanguage":"tr",
      "availableLanguages":[
         "tr",
         "en_US"
      ],
      "affiliate":"TM"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Uzbekistan",
      "mappedToAffiliate":"TR",
      "loginEnabled":true,
      "label":"Uzbekistan",
      "defaultTimezone":"Europe/Istanbul",
      "defaultLocale":"tr_TR",
      "defaultLanguage":"tr",
      "availableLanguages":[
         "tr",
         "en_US"
      ],
      "affiliate":"UZ"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Orientalia",
      "loginEnabled":true,
      "label":"Orientalia",
      "defaultTimezone":"Asia/Bangkok",
      "defaultLocale":"en_US",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"XO"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Bosnia and Herzegovina",
      "loginEnabled":true,
      "label":"Bosnia and Herzegovina",
      "defaultTimezone":"Europe/Berlin",
      "defaultLocale":"hr_HR",
      "defaultLanguage":"hr",
      "availableLanguages":[
         "hr",
         "en_US"
      ],
      "affiliate":"BA"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Mayotte",
      "loginEnabled":true,
      "label":"Mayotte",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"fr_FR",
      "defaultLanguage":"fr",
      "availableLanguages":[
         "fr",
         "en_US"
      ],
      "affiliate":"YT"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Jordan",
      "mappedToAffiliate":"AE",
      "loginEnabled":true,
      "label":"Jordan",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_JO",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US",
         "ar_JO"
      ],
      "affiliate":"JO"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Lebanon",
      "loginEnabled":false,
      "label":"Lebanon",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_LB",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US",
         "fr"
      ],
      "affiliate":"LB"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Lesotho",
      "loginEnabled":true,
      "label":"Lesotho",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"LS"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Malawi",
      "loginEnabled":true,
      "label":"Malawi",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"MW"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Mauritius",
      "loginEnabled":true,
      "label":"Mauritius",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"MU"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Mozambique",
      "loginEnabled":true,
      "label":"Mozambique",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"MZ"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Namibia",
      "loginEnabled":true,
      "label":"Namibia",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"NA"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Nigeria",
      "loginEnabled":true,
      "label":"Nigeria",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"NG"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Rwanda",
      "loginEnabled":true,
      "label":"Rwanda",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"RW"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Somalia",
      "loginEnabled":true,
      "label":"Somalia",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"SO"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Sudan",
      "loginEnabled":true,
      "label":"Sudan",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"SD"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Swaziland",
      "loginEnabled":true,
      "label":"Swaziland",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"SZ"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Uganda",
      "loginEnabled":true,
      "label":"Uganda",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"UG"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Zambia",
      "loginEnabled":true,
      "label":"Zambia",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"ZM"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Zimbabwe",
      "loginEnabled":true,
      "label":"Zimbabwe",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"ZW"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Tanzania",
      "loginEnabled":true,
      "label":"Tanzania",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"TZ"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Republic of the Congo",
      "loginEnabled":true,
      "label":"Congo Republic",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"fr_FR",
      "defaultLanguage":"fr",
      "availableLanguages":[
         "fr",
         "en_US"
      ],
      "affiliate":"CG"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Bahrain",
      "loginEnabled":true,
      "label":"Bahrain",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"BH"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Iran",
      "loginEnabled":true,
      "label":"Iran",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"IR"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Iraq",
      "loginEnabled":true,
      "label":"Iraq",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"IQ"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Kuwait",
      "loginEnabled":true,
      "label":"Kuwait",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"KW"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Libya",
      "loginEnabled":true,
      "label":"Libya",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"LY"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Maldives",
      "loginEnabled":true,
      "label":"Maldives",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"MV"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Oman",
      "loginEnabled":true,
      "label":"Oman",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"OM"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Qatar",
      "loginEnabled":true,
      "label":"Qatar",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"QA"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Syria",
      "loginEnabled":true,
      "label":"Syria",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"SY"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Yemen",
      "loginEnabled":true,
      "label":"Yemen",
      "defaultTimezone":"Asia/Dubai",
      "defaultLocale":"ar_AE",
      "defaultLanguage":"en_US",
      "availableLanguages":[
         "en_US"
      ],
      "affiliate":"YE"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Andorra",
      "mappedToAffiliate":"ES",
      "loginEnabled":true,
      "label":"Andorra",
      "defaultTimezone":"Europe/Brussels",
      "defaultLocale":"es_ES",
      "defaultLanguage":"es",
      "availableLanguages":[
         "es"
      ],
      "affiliate":"AD"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Antigua and Barbuda",
      "loginEnabled":true,
      "label":"Antigua and Barbuda",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es_PA",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"AG"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Bermuda",
      "loginEnabled":true,
      "label":"Bermuda",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es_PA",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"BM"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Bonaire Sinst Eustatius and Saba",
      "loginEnabled":true,
      "label":"Bonaire Sinst Eustatius and Saba",
      "defaultTimezone":"America/Panama",
      "defaultLocale":"es_PA",
      "defaultLanguage":"es_PA",
      "availableLanguages":[
         "es_PA",
         "en_US"
      ],
      "affiliate":"BQ"
   },
   {
      "requestRegistrationEnabled":false,
      "rememberMeEnabled":false,
      "registrationEnabled":true,
      "name":"Democratic Republic of the Congo",
      "loginEnabled":true,
      "label":"Democratic Republic of Congo",
      "defaultTimezone":"Europe/Paris",
      "defaultLocale":"FR",
      "defaultLanguage":"FR",
      "availableLanguages":[
         "FR",
         "en_US"
      ],
      "affiliate":"CD"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":true,
      "registrationEnabled":false,
      "name":"Paraguay",
      "loginEnabled":true,
      "label":"Paraguay",
      "defaultTimezone":"America/Sao_Paulo",
      "defaultLocale":"es_UY",
      "defaultLanguage":"es_UY",
      "availableLanguages":[
         "es_UY"
      ],
      "affiliate":"PY"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Botswana",
      "loginEnabled":true,
      "label":"Botswana",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"BW"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Burundi",
      "loginEnabled":true,
      "label":"Burundi",
      "defaultTimezone":"Africa/Johannesburg",
      "defaultLocale":"en_ZA",
      "defaultLanguage":"en_ZA",
      "availableLanguages":[
         "en_ZA"
      ],
      "affiliate":"BI"
   },
   {
      "requestRegistrationEnabled":true,
      "rememberMeEnabled":false,
      "registrationEnabled":false,
      "name":"Israel",
      "loginEnabled":true,
      "label":"Israel",
      "defaultTimezone":"Jerusalem/Aman GMT+2",
      "defaultLocale":"IW",
      "defaultLanguage":"IW",
      "availableLanguages":[
         "en_us",
         "en_gb",
         "hebrew"
      ],
      "affiliate":"IL"
   }
];